import styled from 'styled-components'

import { down } from '@Globals/Style/breakpoints'
import { flexCenterChildrenColumn } from '@Globals/Style/mixins'

export const SinglePostWrap = styled.div`
  ${flexCenterChildrenColumn};
  margin-bottom: 50px;

  h1:not([class]) {
    font-size: 2.5rem;
    padding-bottom: 0;
    margin-top: 10px;
    line-height: 1.4;

    ${down('desktop')} {
      font-size: 2rem;
    }

    ${down('tablet')} {
      margin-bottom: 10px;
    }
  }

  h2:not([class]) {
    text-align: center;
    margin-top: 20px;
    font-size: 2rem;
    line-height: 1.2;

    ${down('tablet')} {
      font-size: 1.75rem;
      margin-bottom: 5px;
    }

    ${down('phablet')} {
      font-size: 1.5rem;
      margin-bottom: 5px;
      padding-bottom: 0;
    }
  }

  h3:not([class]) {
    text-align: left;
    margin-top: 10px;
    font-size: 1.375rem;

    ${down('phablet')} {
      font-size: 1.25rem;
    }
  }

  p {
    line-height: 1.6;
    padding-bottom: 15px;

    &:empty {
      display: none;
    }

    + ul {
      margin-top: -10px;
    }
  }
`
